import axios from 'axios'
import router from '@/router'
import { message } from 'ant-design-vue';
export function post(url, params = {}) {
  let token = localStorage.getItem("token")
  return axios.post(url, params, {
    headers: {
      'Authentication': token,
    },
  })
}
export function put(url, params = {}) {
  let token = localStorage.getItem("token")
  return axios.put(url, params, {
    headers: {
      'Authentication': token,
    },
  })
}

export function get(url, params = {}) {
  let token = localStorage.getItem("token")
  return axios.get(url, {
    params,
    headers: {
      'Authentication': token,
    }
  })
}
// 下载文件的接口
export function getfile(url, params = {}) {
  let token = localStorage.getItem("token")
  return axios.get(url, {
    params,
    headers: {
      'Authentication': token,
    }, responseType: 'blob'
  })
}

export function del(url, params = {}) {
  let token = localStorage.getItem("token")
  return axios.delete(url, {
    params,
    headers: {
      'Authentication': token,
    }
  })
}
axios.interceptors.response.use(
  response => {
    if (response.data.code != undefined) {
      if (response.data.code != 0 && response.data.code != 2) { //接口访问有问题
        message.destroy()
        message.error(response.data.msg);
        // 当返回信息为未登录或者登录失效的时候重定向为登录页面
        if (response.data.code > 2000 && response.data.code < 2100) {
          router.push({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath } // 从哪个页面跳转
          })
        }
      }
    } else {
    }

    return response
  },
  error => {
    // message.error('网络错误');
    return Promise.reject(error)
  }
)



// WEBPACK FOOTER //
// ./src/http/request.js